import { Environment } from '@campaign-portal/components-library';

export const environment: Environment = {
	production: true,
	version: '1.8.0-0.sha.1758411',
	releaseDate: '2026-06-10T13:00:00Z',

	protocol: '',
	host: '',
	port: '',
	api: 'api',
	localStorageKey: 'ap',
	configURL: `./assets/config.json?v=${Date.now()}`,

	wsHost: '',
	wsPort: '',
	wsApi: 'api/ws',

	title: 'Alaris Labs',
	subTitle: 'Admin Panel',

	theme: 'default',
	themeType: globalThis?.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light',

	termsUrl: '',
	privacyUrl: '',
	supportEmail: '',

	showLink: true,
	allowRegistration: false,
	supportLetsEncrypt: true,

	systemTZOffset: 0,
	localTime: false,

	languagesID: ['en', 'es', 'tr'],

	is2FA: false,
	sessionTimeout: 60,
};
